import React, { Component } from 'react';
import Stats                from '../stats';
import classNames           from 'classnames/bind';
import Stats2Table          from './stats2-table';
import OrdersSummaryTable          from './orders-summary-table';
import UserStats2Table      from './userstats2-table';

export default class Analytics  extends Component {

    constructor(props){
        super(props);

        this.state = {
            isTrend     : false,
            isOrder     : true,
            isOrdersSummary  : false,
            isUserStats : false
        };

        this.enableTrend     = this.enableTrend.bind(this);
        this.enableOrder     = this.enableOrder.bind(this);
        this.enableOrdersSummary   = this.enableOrdersSummary.bind(this);
        this.enableUserStats = this.enableUserStats.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps != null && nextProps.isActive) {
            return true;
        } else {
            return false;
        }
    }

    componentDidMount(){
        if ((typeof google === 'undefined') || (typeof google.visualization === 'undefined')) {
            google.charts.load('current', {packages: ['corechart','table', 'bar']});
        }
    }


    enableTrend(){
        this.setState({
            isTrend     : true,
            isOrder     : false,
            isOrdersSummary     : false,
            isUserStats : false
        });
    }

    enableOrder(){
        this.setState({
            isTrend     : false,
            isOrder     : true,
            isOrdersSummary     : false,
            isUserStats : false
        });
    }
    enableOrdersSummary(){
        this.setState({
            isTrend     : false,
            isOrder     : false,
            isOrdersSummary     : true,
            isUserStats : false
        });
    }

    enableUserStats(){
        this.setState({
            isTrend     : false,
            isOrder     : false,
            isOrdersSummary     : false,
            isUserStats : true
        });
    }

    render(){
        let trendBtnStyle     = classNames('btn',{'btn-dash':!this.state.isTrend},{'btn-dash-active':this.state.isTrend});
        let orderBtnStyle     = classNames('btn',{'btn-dash':!this.state.isOrder},{'btn-dash-active':this.state.isOrder});
        let ordersSummaryBtnStyle     = classNames('btn',{'btn-dash':!this.state.isOrdersSummary},{'btn-dash-active':this.state.isOrdersSummary});
        let userStatsBtnStyle = classNames('btn',{'btn-dash':!this.state.isUserStats},{'btn-dash-active':this.state.isUserStats});

        return (
            <div>
                <div className="section analytics-pg">
                    <div className="row">
                      <div className="col-md-12">
                          <div className="text-center">
                              <button type="submit" className={trendBtnStyle} onClick={this.enableTrend}>Trend</button>
                              <button type="submit" className={orderBtnStyle} onClick={this.enableOrder}>Orders</button>
                              <button type="submit" className={ordersSummaryBtnStyle} onClick={this.enableOrdersSummary}>Orders Summary</button>
                              <button type="submit" className={userStatsBtnStyle} onClick={this.enableUserStats}>Customers</button>
                          </div>
                      </div>
                    </div>
                  </div>

                  {
                      this.state.isTrend
                        ? <Stats
                            google         = {google}
                            activeLocation = {this.props.activeLocation}
                          />
                        : null
                  }

                  {
                      this.state.isOrder
                        ? <Stats2Table
                            google         = {google}
                            activeLocation = {this.props.activeLocation}
                          />
                        : null
                  }
                  {
                      this.state.isOrdersSummary
                        ? <OrdersSummaryTable
                            // google         = {google}
                            activeLocation = {this.props.activeLocation}
                          />
                        : null
                  }

                  {
                      this.state.isUserStats
                        ? <UserStats2Table
                            google         = {google}
                            activeLocation = {this.props.activeLocation}
                          />
                        : null
                  }

            </div>
        );

    }
}






// WEBPACK FOOTER //
// src/components/visualization/analytics.js